module.exports = __webpack_public_path__ + "assets/1792649897182/img/device-location.7df069a4.png";